var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import { SPACING_M, BASE_BORDER_WIDTH, createUIElement } from "../helpers";
import { NavigationMenuTitle } from './controls/NavigationMenuTitle';
import { NavigationMenuItem } from './controls/NavigationMenuItem';
var CSSMinWidth = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: 115px;\n"], ["\n    min-width: 115px;\n"])));
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: inline-flex;\n    flex-shrink: 0;\n    flex-direction: column;\n    height: 100%;\n    background-color: ", ";\n    width: ", ";\n    border-right: ", " solid ", ";\n\n    ", "\n"], ["\n    display: inline-flex;\n    flex-shrink: 0;\n    flex-direction: column;\n    height: 100%;\n    background-color: ", ";\n    width: ", ";\n    border-right: ", " solid ", ";\n\n    ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorNavBackground;
}, function (_a) {
    var width = _a.width;
    return width;
}, BASE_BORDER_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colorNavSideSeparator;
}, CSSMinWidth);
var NavigationGroup = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), CSSMinWidth);
var NavigationSection = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    box-sizing: border-box;\n    flex-grow: 1;\n    padding-top: ", ";\n"], ["\n    box-sizing: border-box;\n    flex-grow: 1;\n    padding-top: ", ";\n"])), SPACING_M);
var getGroupIdArray = function (groups) {
    return groups.reduce(function (result, _a) {
        var id = _a.id;
        result.push(id);
        return result;
    }, []);
};
export var NavigationMenu = createUIElement('NavigationMenu', function (_a, ref) {
    var className = _a.className, _b = _a.width, width = _b === void 0 ? 'auto' : _b, _c = _a.groups, groups = _c === void 0 ? [] : _c, _d = _a.items, items = _d === void 0 ? [] : _d, renderHeader = _a.renderHeader, renderFooter = _a.renderFooter, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "width", "groups", "items", "renderHeader", "renderFooter", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var groupIdArray = useRef(getGroupIdArray(groups));
    useEffect(function () {
        groupIdArray.current = getGroupIdArray(groups);
    }, groups);
    var renderItems = function (items) { return (React.createElement(React.Fragment, null, items === null || items === void 0 ? void 0 : items.map(function (_a) {
        var id = _a.id, icon = _a.icon, title = _a.title, active = _a.active, onClick = _a.onClick, url = _a.url;
        return (React.createElement(React.Fragment, { key: id || Math.random().toString(16) },
            React.createElement(NavigationMenuItem, { icon: icon, title: title, active: active, onClick: onClick, url: url })));
    }))); };
    return (React.createElement(Wrapper, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'navigation', className: "vm-NavigationMenu " + className, width: width, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        renderHeader && renderHeader(),
        items && (React.createElement(NavigationSection, null,
            renderItems((items === null || items === void 0 ? void 0 : items.filter(function (_a) {
                var groupId = _a.groupId;
                var _b;
                return !groupId || ((_b = groupIdArray.current) === null || _b === void 0 ? void 0 : _b.indexOf(groupId)) === -1;
            })) || []), groups === null || groups === void 0 ? void 0 :
            groups.map(function (_a) {
                var id = _a.id, title = _a.title;
                var itemsByGroup = items === null || items === void 0 ? void 0 : items.filter(function (item) { return item.groupId === id; });
                return itemsByGroup.length ? (React.createElement(NavigationGroup, { "data-selector-id": "navigation-group", key: id || Math.random().toString(16) },
                    React.createElement(NavigationMenuTitle, null, title),
                    renderItems(itemsByGroup))) : null;
            }))),
        renderFooter && renderFooter()));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=NavigationMenu.js.map